import {Node, Link} from 'gojs';

import {
  TEXT_COLOR_FOR_SEMI_TRANSPARENT_BACKGROUND as TEXT_COLOR,
  DE_EMPHASIZED_HEX_OPACITY_VALUE,
} from 'src/graph';
import {hexToRGBComponents, quickContrastingBWColor} from 'src/util/colors';
import {toArray} from 'src/util/gojs';

export const isDeEmphasized = (type: string | undefined) => type && type.startsWith('CONTAINS_') || type === 'GROUPS';

export const getColor = ({color, emphasized}: {color: string, emphasized: boolean}) =>
  emphasized ? color + DE_EMPHASIZED_HEX_OPACITY_VALUE : color;

export const getTextColor = ({color, emphasized}: {color: string, emphasized: string}) =>
  emphasized ? TEXT_COLOR : quickContrastingBWColor(...hexToRGBComponents(color));

export const hasAtLeastOneDeEmphasizedRelationship = (n: Node) =>
  toArray<Link>(n.findLinksInto()).some((l) => !l.data.emphasized);
